import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../redux/slices/authSlice";
import presenceService from "../services/presenceService";

const HEARTBEAT_INTERVAL_MS = 20_000;

// Mounted once in AdminLayout and once in CustomerLayout (both — the admin
// Live Traffic page wants real customer activity too, not just staff).
// Fires a heartbeat on every route change, plus on a fixed interval so a
// user sitting still on one page doesn't age out of LiveSession's TTL
// index (90s) between navigations. `pageLabel` is optional, human-readable
// context (e.g. a layout can pass the nav item's label) — falls back to
// the raw path server-side if omitted.
const usePresenceHeartbeat = (pageLabel) => {
  const user = useSelector(selectCurrentUser);
  const location = useLocation();
  const pageLabelRef = useRef(pageLabel);
  pageLabelRef.current = pageLabel;

  useEffect(() => {
    if (!user) return;
    presenceService.heartbeat(location.pathname, pageLabelRef.current).catch(() => {});
  }, [user, location.pathname]);

  useEffect(() => {
    if (!user) return;
    const interval = setInterval(() => {
      presenceService.heartbeat(location.pathname, pageLabelRef.current).catch(() => {});
    }, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location.pathname]);
};

export default usePresenceHeartbeat;
